import styled from 'styled-components';

import { Flexbox } from '@ibinder/common-frontend';

export const ContentContainer = styled.div`
  padding: 0 0 1rem 0;
  height: 100%;
`;

export const ActionsBar = styled(Flexbox)`
  justify-content: space-between;
  border-top: 0.0625rem solid ${({ theme }) => theme.colors.discrete20};
  padding: 0.75rem 1rem;
`;
